<template>
  <div>
    <h2 :class="{ 'mb-4': description }">
      {{ label }}
      <slot />
    </h2>
    <doe-paragraph v-if="description" :description="description" />
  </div>
</template>

<script>
import DoeParagraph from "@/components/typography/Paragraph";

export default {
  name: "DoePageHeading",
  props: {
    label: {
      type: String,
      required: false
    },
    description: {
      type: [Array, String],
      required: false
    }
  },
  components: {
    DoeParagraph
  }
};
</script>

<style lang="scss" scoped>
h2 {
  @apply block font-sans font-semibold leading-none subpixel-antialiased text-4xl text-blue-900;
}
@screen lg {
  h2 {
    @apply leading-tight text-6xl;
  }
}
</style>
